"use client";
import React, { useState } from "react";
import { CustomHero } from "./Branches3";
import { BranchCard2 } from "../../design2/AboutUs2";
import StyledWraper from "../components/StyledWraper";
import CardGrid from "../../../CardGrid";
import { findPropertiesByTypeOptional } from "../../../constants/mockProperties";
import { SecondItem } from "../../design2/AboutUs2";
import { Switch2 } from "../../design2/components/ButtonSwitch";
import { ShowMoreText } from "../../design1/About1";
import { CardVariant3 } from "../../design2/components/CardVariant2";
import { useFetchCompanyInfo } from "src/app/lib/fetchCompanyInfo";
import { BranchSummaryCard } from "../../design1/Branches";
import { useBranches } from "src/app/lib/fetchBranches";
import { ParentCard } from "../../design1/PropertyPage1";
import { PropertyCardSkeleton } from "../../design2/components/Skeletons/Design2PropertyCard";
import Button from "src/app/components/ui/Button";
import BranchCardSkeleton from "../../design2/components/Skeletons/BranchSkeleton";
import { PropertyType } from "src/types";
const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
const AboutUs3 = ({ listings }: { listings: PropertyType[] }) => {
  return (
    <section>
      <CustomHero
        text={`Stay Your next move starts here-browse, find, and secure your perfect property today!" Your next move starts here-browse, find, and secure `}
        header="About Us & Reviews"
      />
      <div className="wrapper py-10">
        <div className="grid-container relative">
          <FirstCol />
          <SecondCol serverproperties={listings} />
        </div>
      </div>
    </section>
  );
};
export default AboutUs3;

const FirstCol = () => {
  const [activeBranch, setActiveBranch] = useState<1 | 2>(1); // Default is 1
  return (
    <div>
      <Switch2
        button1Text="About Us"
        button2Text="Reviews"
        activeState={activeBranch}
        onSwitch={(newState) => setActiveBranch(newState)}
      />
      <div className="items pt-5">
        {activeBranch === 1 ? <FirstItem /> : <SecondItem />}
      </div>
    </div>
  );
};

const SecondCol = ({
  serverproperties,
}: {
  serverproperties: PropertyType[];
}) => {
  const { data: info, isLoading } = useFetchCompanyInfo();
  const summary = info?.companyStat;
  // const { data, isLoading: loadingProperties, isError } = useFetchUnits();
  const loadingProperties = false;
  const isError = false;

  const properties = findPropertiesByTypeOptional();
  const dataToMap = isDemo ? properties : serverproperties;

  return (
    <div className="flex max-h-[1000px] xlg:max-h-[1000000000px] overflow-scroll scrollbar-hide sticky top-[80px] flex-col gap-8 ">
      {!isLoading && !summary ? null : (
        <StyledWraper>
          <BranchSummaryCard
            titleAs="h3"
            loading={isLoading}
            {...{ title: "Company Summary", values: { ...summary } }}
          />
        </StyledWraper>
      )}

      <StyledWraper>
        <div className="recent bg-white shadow-md p-4 rounded-xl  gap-8">
          <div className="first py-2 flex items-center justify-between">
            <h3 className="text-secondary-main h4 !font-semibold">
              Recent Listings
            </h3>
            {dataToMap && dataToMap.length > 0 && (
              <Button
                variant="new"
                className="text-themeColor h-max"
                href="/properties"
              >
                See More
              </Button>
            )}
          </div>
          <CardGrid maxColumns={2}>
            {(() => {
              if (isDemo && dataToMap?.length) {
                return dataToMap.map((item, index) => (
                  <CardVariant3
                    className="!h-full block"
                    key={index}
                    {...item}
                  />
                ));
              }

              if (loadingProperties) {
                return Array.from({ length: 8 }).map((_, index) => (
                  <PropertyCardSkeleton key={index} />
                ));
              }

              if (isError) {
                return (
                  <div className="text-red-500">
                    There was an error loading properties.
                  </div>
                );
              }

              if (dataToMap?.length) {
                return dataToMap.map((item, index) => (
                  <CardVariant3
                    className="!h-full block"
                    key={index}
                    {...item}
                  />
                ));
              }

              return (
                <div className="text-gray-500">
                  Looks like there haven’t been any new property updates yet.
                </div>
              );
            })()}
          </CardGrid>
        </div>
      </StyledWraper>
    </div>
  );
};

const FirstItem = () => {
  const { data: branches, isLoading } = useBranches();
  const { data: info, isLoading: loadingInfo } = useFetchCompanyInfo();
  return (
    <div className="flex-col mt-6 flex gap-8">
      {!loadingInfo && !info?.companyInfo?.about ? null : (
        <StyledWraper>
          <ParentCard headingTag="h3" header="About Us">
            <ShowMoreText
              loading={loadingInfo}
              maxLength={300}
              text={info?.companyInfo?.about || "No information available"}
            />
          </ParentCard>
        </StyledWraper>
      )}

      <StyledWraper>
        <ParentCard headingTag="h3" header="Branches">
          <CardGrid className="" gap={0} maxColumns={1}>
            {isLoading ? (
              <BranchCardSkeleton count={8} />
            ) : branches && branches.length > 0 ? (
              branches.map((item, index) => (
                <div key={index} className="py-4">
                  <BranchCard2
                    addressAs="h5"
                    titleAs="h4"
                    variant
                    key={index}
                    {...item}
                  />
                </div>
              ))
            ) : (
              <p className="text-sm text-gray-500">
                We’re currently updating our branch details. Soon, you’ll be
                able to view the locations, contact information, and services
                offered by our various branches across the region. Please check
                back shortly for the latest updates.
              </p>
            )}
          </CardGrid>
        </ParentCard>
      </StyledWraper>
    </div>
  );
};

export const mockCompanyDesc = `<p>Welcome to NexusTech Solutions, a cutting-edge technology company dedicated to revolutionizing the digital landscape. With a deep-rooted passion for innovation, we strive to develop transformative solutions that help businesses navigate the ever-evolving world of technology. Our expertise spans a wide range of industries, allowing us to craft customized solutions that drive efficiency, enhance customer experiences, and fuel growth. Whether you're a startup looking to establish a solid technological foundation or a large enterprise seeking to optimize operations, NexusTech Solutions is here to bring your vision to life.</p>

<p>At NexusTech, we specialize in providing innovative software solutions, AI-driven automation, and cloud-based services that empower businesses to scale efficiently. Our team of engineers, developers, and data scientists is committed to pushing the boundaries of what's possible, ensuring our clients always stay ahead of the competition. From intelligent automation that streamlines workflows to cloud infrastructure that enhances scalability and security, our solutions are designed to meet the unique challenges of modern businesses. We take pride in delivering seamless integrations, user-friendly platforms, and data-driven strategies that translate into measurable success.</p>

<p>With a strong emphasis on technological excellence, our team continuously explores emerging trends, staying at the forefront of industry advancements. Our commitment to research and development allows us to harness the power of artificial intelligence, machine learning, and big data analytics to create intelligent systems that adapt to market demands. Whether it's predictive analytics for business intelligence, blockchain solutions for secure transactions, or custom software development for industry-specific needs, NexusTech is dedicated to delivering future-ready solutions that redefine how businesses operate.</p>

<p>Customer satisfaction is at the heart of everything we do, and we believe in forging long-lasting partnerships built on trust, transparency, and results. Our client-centric approach ensures that every solution we deliver is tailored to specific business needs, providing maximum impact and efficiency. We take the time to understand our clients' goals, challenges, and aspirations, enabling us to develop strategies that align with their long-term vision. With 24/7 support, dedicated account managers, and a results-driven mindset, NexusTech goes beyond being just a service provider—we become a true extension of your team.</p>

<p>Headquartered in Silicon Valley, NexusTech Solutions serves a diverse global clientele, ranging from ambitious startups to Fortune 500 companies. Our presence extends beyond geographical boundaries, allowing us to cater to businesses in various markets, industries, and scales. By leveraging a robust network of industry experts, strategic partners, and cutting-edge technology, we ensure that our clients receive world-class solutions, regardless of their location. We understand the complexities of global business landscapes and are committed to providing seamless digital transformation strategies that drive sustainable success.</p>

<p>Whether you need AI-powered analytics, secure cloud infrastructure, enterprise software development, or digital transformation consulting, NexusTech Solutions is your trusted partner in innovation. Our mission is to empower businesses with technology that not only meets their current needs but also prepares them for the future. With a relentless pursuit of excellence, we continue to redefine possibilities, creating intelligent, efficient, and scalable solutions that elevate businesses to new heights. Partner with NexusTech today and take a bold step into the future of technology—where innovation knows no limits.</p>
`;
